import { UserOutlined } from '@ant-design/icons';
import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';
import styled from '@emotion/styled';
import toLowerCase from 'utils/toLowerCase';
import { regionBuyerDetailHostMap } from 'services/config/region';
import { openExternalURL } from 'utils/openExternalURL';
import { useXiapibuyEnable } from 'hooks/useXiapibuyEnable';

const Container = styled.div`
  width: 250px;
`;

const Info = styled.div`
  display: flex;
  > * {
    flex: 0 0 auto;
  }
  > div {
    flex: 1 0 0;
    margin-left: 4px;
    font-weight: 500;
    word-break: break-all;
    color: var(--fett-text-primary);
  }
`;

const Avatar = styled.span<{ src?: string }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 56px;
  height: 56px;
  font-size: 30px;
  background: ${({ src }) => (src ? `center / cover no-repeat url(${src})` : '#ccc')};
  color: #fff;
  border-radius: 28px;
`;

const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    cursor: pointer;
    &:hover {
      color: #fa6400;
    }
  }
`;

export interface BuyerDetailProps extends HTMLAttributes<HTMLElement> {
  platform: General.CaselessPlatformTunnel;
  region: General.CaselessRegion;
  avatar?: string;
  nick: string;
}

function BuyerDetail(props: BuyerDetailProps) {
  const { platform, region, avatar, nick } = props;

  const { t } = useTranslate();

  const isSupportDetail = toLowerCase(platform) === 'shopee';

  const xiapibuyEnable = useXiapibuyEnable(region);

  let host = `https://${toLowerCase(region)}.xiapibuy.com`;
  if (!xiapibuyEnable) {
    const r = regionBuyerDetailHostMap[toLowerCase(region)];
    if (r) {
      host = r;
    }
  }

  const detailPath = `${host}/${nick}`;

  return (
    <Container>
      <Info>
        <Avatar src={avatar}>{avatar ? null : <UserOutlined />}</Avatar>
        <div>{nick}</div>
      </Info>
      {isSupportDetail && (
        <Toolbar>
          <span />
          <div
            onClick={() => {
              openExternalURL(detailPath, '__blank');
            }}
          >
            {`${t('scene.chatWorkspace.currentConversation.action.viewDetails')} >`}
          </div>
        </Toolbar>
      )}
    </Container>
  );
}

export default BuyerDetail;
